import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { candidateStagesById, type CandidateStatusId } from '@/types/candidate';

const getStageLabel = (stage: CandidateStatusId | null | undefined): string => {
  if (!stage) {
    return 'Onbekende fase';
  }

  return candidateStagesById.get(stage)?.label ?? stage;
};

type StageTransitionWarningDialogProps = {
  open: boolean;
  fromStage: CandidateStatusId | null;
  toStage: CandidateStatusId | null;
  description?: string;
  onConfirm?: () => void;
  onCancel?: () => void;
};

const StageTransitionWarningDialog = ({
  open,
  fromStage,
  toStage,
  description,
  onConfirm,
  onCancel,
}: StageTransitionWarningDialogProps) => {
  const fromLabel = getStageLabel(fromStage);
  const toLabel = getStageLabel(toStage);

  const handleOpenChange = (nextOpen: boolean) => {
    if (!nextOpen) {
      onCancel?.();
    }
  };

  const handleConfirm = () => {
    onConfirm?.();
  };

  const handleCancel = () => {
    onCancel?.();
  };

  return (
    <Dialog open={open} onOpenChange={handleOpenChange}>
      <DialogContent className='bg-white border-gray-100'>
        <DialogHeader>
          <DialogTitle>Controleer deze statuswijziging</DialogTitle>
          <DialogDescription>
            {description ??
              'Deze overgang vereist binnenkort aanvullende informatie. Controleer of de kandidaat klaar is om deze status te krijgen.'}
          </DialogDescription>
        </DialogHeader>
        <div className="rounded-md border border-dashed border-slate-200 bg-slate-50 px-4 py-3 text-sm">
          <p className="m-0 text-slate-500">Van</p>
          <p className="m-0 text-base font-semibold">{fromLabel}</p>
          <p className="m-0 pt-3 text-slate-500">Naar</p>
          <p className="m-0 text-base font-semibold">{toLabel}</p>
        </div>
        <DialogFooter>
          <Button variant="outline" onClick={handleCancel} type="button">
            Annuleren
          </Button>
          <Button onClick={handleConfirm} type="button">
            Ga verder
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};

export default StageTransitionWarningDialog;
